export enum Severity {
  ERROR = "error",
  SUCCESS = "success",
}
